// extracted by mini-css-extract-plugin
export default {"resultContainer":"Result_resultContainer__bpvHJ","icon":"Result_icon__YlQzl","resultBox":"Result_resultBox__KVFPF"};